import {useMutation, useQueryClient} from '@tanstack/react-query';

import {createGeoFilter, CreateGeoFilterParams} from '../api';
import {QUERY__GEO_FILTER_OPTIONS} from '../queryKeys';

export const useCreateGeoFilter = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateGeoFilterParams) => createGeoFilter(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__GEO_FILTER_OPTIONS],
      });
    },
  });
};
